import * as React from "react"

const Location = () => null

export default Location